import { Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/navbar/Navbar';
import AppPage from './pages/AppPage';
import HomePage from './pages/HomePage';
import AppDetailsPage from './pages/AppDetailsPage'; 
import DeleteAccountPage from './pages/DeleteAccountPage';
import ContactPage from './pages/ContactPage';
import TechStackPage from './pages/TechStackPage';
import { Footer } from './components/footer/Footer';
import ThankYouPage from './pages/ThankYouPage';
import AboutPage from './pages/AboutPage';

function App() {
  return (
    <div className="App">
      <Navbar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/apps" element={<AppPage />} />
        <Route path="/tech-stack" element={<TechStackPage />} />
        <Route path="/apps" element={<AppPage />} />
        <Route path="/apps/:slug" element={<AppDetailsPage />} />
        <Route path="/delete-account" element={<DeleteAccountPage />} />
        <Route path='/thank-you' element={<ThankYouPage />} />
      </Routes>
      <Footer />
    </div>
  );
}

export default App;
